import type { Meta, StoryObj } from "@storybook/react";

import { Switch } from "@/ui/core";
import type { SwitchProps } from "@/ui/core/Switch";

const StoryMeta: Meta<SwitchProps> = {
  title: "Core/Switch",
  component: Switch,
  argTypes: {
    isDefaultChecked: { control: "boolean" },
    onCheckedChange: { action: "onCheckedChange" },
    testID: { control: "text" },
  },
  args: {
    testID: "storybook",
  },
};

type Story = StoryObj<SwitchProps>;

const Primary: Story = {};
const Checked: Story = {
  args: { isDefaultChecked: true },
};

export { Checked, Primary };
export default StoryMeta;
